module.exports = __webpack_public_path__ + "static/media/17_plantilla_rec_combo_simple_cf_gaseosas_pet_15_sw.21deb28c.png";